import { useTranslation } from '@bonanza-social/i18n';
import { Box, Text, Image, ProgressBar } from '@bonanza-social/moonlight';
import useLoyalty from '../../hooks/useLoyalty';

function LevelProgressInfo() {
  const [t] = useTranslation('levels');
  const { loyalty, points } = useLoyalty();

  return (
    <Box>
      {loyalty ? (
        <Box alignItems="center" gap="space-400">
          <Image
            name="levels.LevelUpSpinningArrow"
            autoplay
            width={250}
            height={250}
          />

          <Box width="100%" gap="space-100" padding="space-200">
            <Text variant="nav-label" color="darkSurfacePrimary">
              {`${t('level')} ${loyalty.level}`}
            </Text>

            <ProgressBar
              width="100%"
              level={loyalty.level}
              from={loyalty.startPoints}
              to={loyalty.endPoints}
              progress={points}
            />
          </Box>

          <Text
            variant="body-m"
            color="darkSurfacePrimary"
            locNS="levels"
            locKey="levelUpMessage"
          />

          <Text
            variant="caption-semi"
            color="darkSurfaceSecondary"
            locNS="levels"
            locKey="levelUpSubMessage"
          />
        </Box>
      ) : null}
    </Box>
  );
}

export default LevelProgressInfo;
